import { ATX_BREAKPOINT_WIDTH } from '@epicuro-next/ataraxia/breakpoint';

// we don't have a breakpoint larger than XL desktop, but it's still too small to fit 4 inventories
// so we need an arbitrary breakpoint
const INVENTORY_OVERVIEW_WIDTH = 18 * 16; // 18 rem width to pixels

export const getVisibleInventoriesLimit = (
  width: number,
  maxInventoriesRule = 0,
) => {
  if (maxInventoriesRule > 0 && width > ATX_BREAKPOINT_WIDTH.MD) {
    return maxInventoriesRule;
  }

  if (width > ATX_BREAKPOINT_WIDTH.XL + INVENTORY_OVERVIEW_WIDTH) {
    return 4;
  }
  if (width > ATX_BREAKPOINT_WIDTH.XL) {
    return 3;
  }
  if (width > ATX_BREAKPOINT_WIDTH.MD) {
    return 2;
  }
  return 1;
};
